module.exports = __webpack_public_path__ + "static/media/renewProfile.713e97de.png";